import { API_BASE_URL } from '../globals';
import {
  CUSTOMER_FETCH_ALL_DATA,
  MASTERS_FETCH_ALL_DATA,
  MASTERS_ADD_NEW,
  MASTERS_SEARCH_ORGANISATION,
  MASTERS_APPROVE_REQUEST,
  MASTERS_DISAPPROVE_REQUEST, MASTERS_EDIT,
  MASTERS_SEARCH_CUSTOMER,
  MASTERS_DELETE_CUSTOMER,
  CREATE_ORGANISATION_GROUP,
  FETCH_ORGANISATION_FF_GROUPS,
  VALIDATE_FF_GROUP_NAME,
  ASSIGN_GROUP_TO_ORGANISATION,
  MASTER_FETCH_ALL_STAKEHOLDERS,
  MASTERS_FETCH_COUNT_FOR_MASTER_VIEW,
  GET_SHIPPERS,
  TOGGLE_FREIGHT_MODE,
  ENABLE_MODE_OF_SERVICE,
  FETCH_LINKED_FFS, ADD_SPOC,
  CREATE_STAKEHOLDER,
  EDIT_STAKEHOLDER,
  DELETE_STAKEHOLDER ,
  SEARCH_STAKEHOLDER,
  CHANGE_CONNECTION_STATUS,
  FETCH_KYC_DATA,
  SEND_CONNECTION_REQUEST,
  PRODUCT_BULK_UPLOAD,
  STAKEHOLDER_BULK_UPLOAD,
  STAKEHOLDER_BULK_UPDATE,
  STAKEHOLDER_BULK_SAMPLE_DOWNLOAD,
  PRODUCT_BULK_SAMPLE_DOWNLOAD,
  CUSTOMER_BULK_SAMPLE_DOWNLOAD,
  CUSTOMER_BULK_UPLOAD,
  MASTER_FETCH_ALL_STAKEHOLDERS_PAGINATED,
  STAKEHOLDER_DOWNLOAD_RESULTS,
  PRODUCT_MASTER_BULK_UPLOAD,
  PRODUCT_MASTER_BULK_SAMPLE_DOWNLOAD,
  SEARCH_SHIPMENT_OWNER,
  AIR_CARGO_INTERNAL_REFERENCE_NUMBERS_SEARCH,
  STAKEHOLDER_ADD_VENDOR,
  STAKEHOLDER_INITIATE_ONBOARDING,
  STAKEHOLDER_DELETE_VENDOR_INVITATION,
  STAKEHOLDER_RESEND_VENDOR_INVITATION,
  STAKEHOLDER_VENDOR_ACTION_LOGS,
  UPDATE_VENDOR_INFORMATION,
  STAKEHOLDER_CHILD_BASE,
  DOCUMENT_MASTER_CREATE,
  DOCUMENT_MASTER_UPDATE,
  DOCUMENT_MASTER_DELETE,
  DOCUMENT_MASTER_FETCH,
  PRODUCT_BULK_UPDATE,
} from './routes';
import {
  GET,
  POST,
  PATCH ,
  DELETE,
} from './apiHandler';
import { OrgTypes, StakeholderTypes, Modules } from 'src/Library/Constants';

export const customerAllData = async (pagination: any, typeFilter, signal?: AbortSignal) => {
  return POST(`${API_BASE_URL}${CUSTOMER_FETCH_ALL_DATA}`, { ...pagination, typeFilter }, undefined, false, signal);
};

export const fetchAllData = async (body, signal?: AbortSignal) => {
  return POST(`${API_BASE_URL}${MASTERS_FETCH_ALL_DATA}`, body, undefined, false, signal);
};

export const searchOrganisation = async (organisationType: string, query: string) => {
  return GET(
    `${API_BASE_URL}${MASTERS_SEARCH_ORGANISATION}`,
    {
      organisationType,
      query,
    },
  );
};

export const searchCustomer = async (
  organisationType: string,
  query: string,
  type = 'CUSTOMER',
) => {
  return GET(
    `${API_BASE_URL}${MASTERS_SEARCH_CUSTOMER}`,
    {
      organisationType,
      query,
      type,
    },
  );
};

export const addNewMaster = async (params) => {
  return POST(`${API_BASE_URL}${MASTERS_ADD_NEW}`, params);
};

export const editMaster = async (params) => {
  return POST(`${API_BASE_URL}${MASTERS_EDIT}`, params);
};

export const approveRequest = async (params) => {
  return POST(`${API_BASE_URL}${MASTERS_APPROVE_REQUEST}`, params);
};

export const disapproveRequest = async (params) => {
  return POST(`${API_BASE_URL}${MASTERS_DISAPPROVE_REQUEST}`, params);
};

export const deleteCustomer = async (params) => {
  return POST(`${API_BASE_URL}${MASTERS_DELETE_CUSTOMER}`, params);
};

export const fetchCountForMasterView = async (params) => {
  return GET(`${API_BASE_URL}${MASTERS_FETCH_COUNT_FOR_MASTER_VIEW}`, params);
};

export const getShippers = async (queryString) => {
  return POST(`${API_BASE_URL}${GET_SHIPPERS}`, queryString);
};

export const toggleFreightMode = async (params) => {
  return POST(`${API_BASE_URL}${TOGGLE_FREIGHT_MODE}`, params);
};

export const enableModeOfService = async (params: { onboardingId: number; reason?: string }) => {
  return POST(`${API_BASE_URL}${ENABLE_MODE_OF_SERVICE}`, params);
};

export const fetchVendorDetails = async (onboardingId: string | number) => {
  return GET(`${API_BASE_URL}${STAKEHOLDER_VENDOR_ACTION_LOGS}/${onboardingId}`);
};

export const fetchVendorActionLogs = async (onboardingId: string | number) => {
  const url = `${API_BASE_URL}${STAKEHOLDER_VENDOR_ACTION_LOGS}/${onboardingId}/action-logs`;
  const result = await GET(url);
  if (!result.isSuccess) {
    return result;
  }
  const logs = (result.data?.data?.logs || result.data?.logs) ?? [];
  return {
    ...result,
    data: { logs },
  };
};

export const fetchLinkedFFs = async (params) => {
  return POST(`${API_BASE_URL}${FETCH_LINKED_FFS}`, params);
};

export const createOrganisationGroup = async (params) => {
  return POST(`${API_BASE_URL}${CREATE_ORGANISATION_GROUP}`, params);
};

export const fetchOrganisationFFGroups = async (params) => {
  return POST(`${API_BASE_URL}${FETCH_ORGANISATION_FF_GROUPS}`, params);
};

export const validateFFGroupName = async (params) => {
  return POST(`${API_BASE_URL}${VALIDATE_FF_GROUP_NAME}`, params);
};

export const assignGroupToOrganisation = async (params) => {
  return POST(`${API_BASE_URL}${ASSIGN_GROUP_TO_ORGANISATION}`, params);
};

export const createStakeholder = async (params) => {
  return POST(`${API_BASE_URL}${CREATE_STAKEHOLDER}`, params);
};

export const fetchAllStakeholders = async (params) => {
  return GET(`${API_BASE_URL}${MASTER_FETCH_ALL_STAKEHOLDERS}`, params);
};

export const fetchAllStakeholdersPaginated = async (params, signal?: AbortSignal) => {
  return  GET(`${API_BASE_URL}${MASTER_FETCH_ALL_STAKEHOLDERS_PAGINATED}`, params, undefined, undefined, signal);
}

export const addSpoc = async (params) => {
  return POST(`${API_BASE_URL}${ADD_SPOC}`, params);
};

export const editPOC = async (params) => {
  return PATCH(`${API_BASE_URL}${ADD_SPOC}`, params);
};

export const editStakeholder = async(params) => {
  return PATCH(`${API_BASE_URL}${EDIT_STAKEHOLDER}`, params);
};

export const searchStakeholder = async (params) => {
  return GET(`${API_BASE_URL}${SEARCH_STAKEHOLDER}`, params);
};

export const searchInternalReferenceNumbers = async (params) => {
  return GET(`${API_BASE_URL}${AIR_CARGO_INTERNAL_REFERENCE_NUMBERS_SEARCH}`, params);
};

export const searchShipmentOwner = async (params) => {
  return GET(`${API_BASE_URL}${SEARCH_SHIPMENT_OWNER}`, params);
};

export const deleteStakeholder = async (params) => {
  return await DELETE(`${API_BASE_URL}${DELETE_STAKEHOLDER}`, params);
};

export const changeConnectionStatus = async (body) => {
  return POST(`${API_BASE_URL}${CHANGE_CONNECTION_STATUS}`, body);
}

export const fetchKycData = async (body) => {
  return POST(`${API_BASE_URL}${FETCH_KYC_DATA}`, body);
}

export const sendConnectionRequest = async (body) => {
  return POST(`${API_BASE_URL}${SEND_CONNECTION_REQUEST}`, body);
}

export const productBulkUpload = async (body: {
  s3FileUrl: string;
  fileName: string;
}) => {
  return POST(`${API_BASE_URL}${PRODUCT_BULK_UPLOAD}`, body);
}

export const productBulkUpdate = async (body: {
  s3FileUrl: string;
  fileName: string;
}) => {
  return POST(`${API_BASE_URL}${PRODUCT_BULK_UPDATE}`, body);
}

export const productMasterBulkUpload = async (body: {
  s3FileUrl: string;
  fileName: string;
}) => {
  return POST(`${API_BASE_URL}${PRODUCT_MASTER_BULK_UPLOAD}`, body);
}

export const productSampleDownload = async (isEdit: boolean) => {
  // const params = isEdit !== undefined ? { isEdit: isEdit.toString() } : {};
  return GET(`${API_BASE_URL}${PRODUCT_BULK_SAMPLE_DOWNLOAD}`, { isEdit }, 'blob');
}

export const productMasterSampleDownload = async () => {
  return GET(`${API_BASE_URL}${PRODUCT_MASTER_BULK_SAMPLE_DOWNLOAD}`, {}, 'blob');
}

export const customerMasterSampleDownload = async (body) => {
  return GET(`${API_BASE_URL}${CUSTOMER_BULK_SAMPLE_DOWNLOAD}`, body, 'blob');
}

export const customerMasterBulkUpload = async (body: {
  s3FileUrl: string;
  fileName: string;
  stakeholderType: string;
}) => {
  return POST(`${API_BASE_URL}${CUSTOMER_BULK_UPLOAD}`, body);
}

export const stakeholderMasterBulkUpdate = async (body: {
  s3FileUrl: string;
  fileName: string;
  stakeholderType: string;
}) => {
  return POST(`${API_BASE_URL}${STAKEHOLDER_BULK_UPDATE}`, body);
}

export const stakeholderMasterBulkUpload = async (body: {
  s3FileUrl: string;
  fileName: string;
  stakeholderType: Pick<typeof OrgTypes, OrgTypes.CUSTOMER | OrgTypes.SUPPLIER>,
}) => {
  return POST(`${API_BASE_URL}${STAKEHOLDER_BULK_UPLOAD}`, body);
}

export const stakeholderMasterSampleDownload = async (body: {
  stakeholderType: string;
  isEdit?: boolean;
}) => {
  return GET(`${API_BASE_URL}${STAKEHOLDER_BULK_SAMPLE_DOWNLOAD}`, body, 'blob');
}

export const downloadStakeholders = async (params) => {
  return GET(`${API_BASE_URL}${STAKEHOLDER_DOWNLOAD_RESULTS}`, params, 'blob');
}

export const addVendor = async (body: {
  email: string;
  vendorCode?: string;
  stakeholderType: string;
  modesOfService: string[];
  term: string;
  dueDate: string;
  replicateForOrgs?: string[];
  replicateForAllChildOrgs?: boolean;
}) => {
  return POST(`${API_BASE_URL}${STAKEHOLDER_ADD_VENDOR}`, body);
}

export const initiateStakeholderOnboarding = async (body: {
  email: string;
  organisationType: OrgTypes;
  stakeholderType: StakeholderTypes;
  modules: Modules[];
  stakeholderName?: string;
  childStakeholderCode?: string;
}) => {
  return POST(`${API_BASE_URL}${STAKEHOLDER_INITIATE_ONBOARDING}`, body);
}

export const resendVendorInvitation = async (body: {
  id: string;
}) => {
  return POST(`${API_BASE_URL}${STAKEHOLDER_RESEND_VENDOR_INVITATION}`, body);
}

export const deleteVendorInvitation = async (body: {
  id: string;
}) => {
  return DELETE(`${API_BASE_URL}${STAKEHOLDER_DELETE_VENDOR_INVITATION}`, body);
}

export const updateVendorDetails = async (body) => {
  return POST(`${API_BASE_URL}${UPDATE_VENDOR_INFORMATION}`, body);
}

export const documentMasterFetch = async (body?: any, signal?: AbortSignal) => {
  return GET(`${API_BASE_URL}${DOCUMENT_MASTER_FETCH}`, body, undefined, undefined, signal);
}
export const documentMasterCreate = async (body) => {
  return POST(`${API_BASE_URL}${DOCUMENT_MASTER_CREATE}`, body);
}
export const documentMasterUpdate = async (body) => {
  return PATCH(`${API_BASE_URL}${DOCUMENT_MASTER_UPDATE}`, body);
}
export const documentMasterDelete = async (body) => {
  return DELETE(`${API_BASE_URL}${DOCUMENT_MASTER_DELETE}`, body);
}

export const enableChildStakeholder = async (onboardingId: string) => {
  return PATCH(`${API_BASE_URL}${STAKEHOLDER_CHILD_BASE}/${onboardingId}/enable`, null);
}

export const disableChildStakeholder = async (onboardingId: string) => {
  return PATCH(`${API_BASE_URL}${STAKEHOLDER_CHILD_BASE}/${onboardingId}/disable`, null);
}

export const fetchChildStakeholderDetails = async (onboardingId: string) => {
  return GET(`${API_BASE_URL}${STAKEHOLDER_CHILD_BASE}/${onboardingId}`);
}

export const editChildStakeholder = async (onboardingId: string, body: {
  childStakeholderCode: string;
  modules: string[];
}) => {
  return PATCH(`${API_BASE_URL}${STAKEHOLDER_CHILD_BASE}/${onboardingId}/edit`, body);
}
